"use client";

import { Gem, MessagesSquare, Home } from "lucide-react";
import { MaskedHeadline, Reveal, EngravedLine } from "./motion-primitives";

const PILLARS = [
  {
    icon: Gem,
    title: "Quality-Focused Work",
    copy: "Every project is approached with care and attention to the finished result.",
  },
  {
    icon: MessagesSquare,
    title: "Clear Communication",
    copy: "Know what comes next and receive personalized guidance throughout the quote process.",
  },
  {
    icon: Home,
    title: "Family-Owned Service",
    copy: "Work directly with a business that values relationships, responsiveness, and long-term trust.",
  },
];

export function WhyUs() {
  return (
    <section className="bg-softwhite py-24 sm:py-32">
      <div className="mx-auto max-w-[1400px] px-5">
        <h2 className="max-w-3xl font-display text-[clamp(2.2rem,5vw,4rem)] leading-[0.96] font-bold text-ink">
          <MaskedHeadline lines={["Personal service is", "part of every project."]} />
        </h2>
        <EngravedLine className="mt-12" />

        <div className="mt-4 grid lg:grid-cols-3">
          {PILLARS.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.1}>
              <div
                className={`flex h-full flex-col gap-6 py-12 lg:px-10 ${
                  i === 1 ? "lg:border-x lg:border-ink/10" : ""
                } ${i === 0 ? "lg:pl-0" : ""}`}
              >
                <p.icon className="size-7 text-brass" aria-hidden strokeWidth={1.5} />
                <h3 className="font-display text-2xl leading-tight font-semibold text-ink">
                  {p.title}
                </h3>
                <p className="text-sm leading-relaxed text-muted-foreground">{p.copy}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-4 inline-flex items-center gap-3 rounded-full bg-ivory px-5 py-3 text-xs font-semibold tracking-wide text-ink">
            <span className="size-1.5 rotate-45 bg-brass" aria-hidden />
            Serving customers with personal care since 2019.
          </p>
        </Reveal>
      </div>
    </section>
  );
}